var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-left"},[(_vm.blankCount > 0 && _vm.wrongCount < 6)?_c('h4',{staticClass:"neigh"},[_vm._v(" "+_vm._s(_vm.wrongGuesses.join(" "))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }